<template>
    <div class="main-container map-dashboard">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <mapLocationHistory :settings="mapLocationHistorySettings"></mapLocationHistory>
<!--        <customModalMapDashboard :settings="customModalMapDashboard"></customModalMapDashboard>-->
        <div class="map-header">
            <div class="range">
                    <div class="range-select__wrapper">
                        <div @click="onAVLogoClick" class="map-logo" @contextmenu.prevent="onAVLogoContextMenuClick">
                            <img src="@/assets/landing/logo.svg" alt="AirVote Logo">
                        </div>
                        <div class="range-select">
                            <div class="dropdown-range">
                                <h6>{{ translate('own_selectRange') }}:</h6>
                                <b-dropdown :text="getDateRangeTypeTranslation()" no-caret>
                                    <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.TODAY)">
                                        <span>{{ translate('own_today') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.LAST7DAYS)">
                                        <span>{{ translate('own_last7days') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.ALL_TIME)">
                                        <span>{{ this.translate('own_allTime') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.CUSTOM)">
                                        <span>{{ this.translate('own_custom') }}...</span>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                            <div class="dropdown-range dates" v-if="dateRange.type == CONSTANTS.CUSTOM">
                                <div class="calendar-inline">
                                    <div class="custom_date_selector">
                                        <label class="date_lbl">{{ translate('From') }}:</label>
                                        <div :class="[!dateRangeView.showDateFrom ? 'hide-picker' : '']">
                                            <date-picker
                                                name="date"
                                                id="datefrom"
                                                v-model="dateRangeView.dateFrom"
                                                :config="dateRangeView.options"
                                                @dp-hide="onDatePickerHidden"
                                                @dp-change="onDateFromChanged"
                                            ></date-picker>
                                        </div>
                                        <label @click="dateRangeView.showDateFrom = !dateRangeView.showDateFrom" class="btn"
                                               for="datefrom">
                                            <img src="@/assets/icons/ic_calendar-1.svg">
                                        </label>
                                    </div>
                                </div>
                                <div class="calendar-inline">
                                    <div class="custom_date_selector">
                                        <label class="date_lbl">{{ translate('To') }}:</label>
                                        <div :class="[!dateRangeView.showDateTo ? 'hide-picker' : '']">
                                            <date-picker
                                                name="date"
                                                id="dateto"
                                                v-model="dateRangeView.dateTo"
                                                :config="dateRangeView.options"
                                                @dp-hide="onDatePickerHidden"
                                                @dp-change="onDateToChanged"></date-picker>
                                        </div>
                                        <label @click="dateRangeView.showDateTo = !dateRangeView.showDateTo" class="btn"
                                               for="dateto">
                                            <img src="@/assets/icons/ic_calendar-1.svg">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="placesFilter.available.length > 1 || (placesFilter.available.length == 0 && placesFilter.selection.length == 0)">
                            <h6>Select sites:</h6>
                            <multiselect v-model="placesFilter.selection" :options="placesFilter.available" :multiple="true"
                                         :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                                         placeholder="" label="short_tag" track-by="uid" :preselect-first="false"
                                         select-label="" deselect-label="" :show-labels="false" :searchable="false" :allow-empty="false"
                                         :hide-selected="true"
                                         @input="onPlacesFilterChanged" :block-keys="[]">
                                <!--                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></template>-->
                            </multiselect>
                        </div>
                        <div class="range-select">
                            <div class="address_wrapper placement_filter">
                                <md-field>
                                    <label>{{ this.translate('own_map_Placement') }}</label>
                                    <md-input
                                        @input="onPlacementChanged"
                                        class="autocomplete"
                                        v-model="filterPlacement">
                                    </md-input>
                                </md-field>
                            </div>
                        </div>
                        <div class="range-select">
                            <div class="address_wrapper sld_filter">
                                <md-field>
                                    <label>{{ this.translate('own_map_Sld') }}</label>
                                    <md-input
                                        @input="onSldFilterChanged"
                                        class="autocomplete"
                                        v-model="filterSld">
                                    </md-input>
                                </md-field>
                            </div>
                        </div>
                        <div class="range-select">
                            <div class="address_wrapper question_id_filter">
                                <md-field>
                                    <label>{{ this.translate('own_map_Question') }}</label>
                                    <md-input
                                        @input="onQuestionIdFilterChanged"
                                        class="autocomplete"
                                        type="number"
                                        v-model="filterQId">
                                    </md-input>
                                </md-field>
                            </div>
                        </div>
                        <div class="range-select" v-if="false">
                            <div class="address_wrapper">
                                <md-autocomplete
                                    :md-options="autocompleteAddressCollection"
                                    @md-changed="onSearchAddressChanged"
                                    @md-selected="onSearchAddressSelect"
                                    class="autocomplete"
                                    v-model="searchAddressQuery">
                                    <label>{{this.translate('own_Address')}}</label>

                                    <template class="addressDropdownItem" slot="md-autocomplete-item"
                                              slot-scope="{ item }">
                                        <md-highlight-text>{{ item.main_text }}</md-highlight-text>
                                        <md-highlight-text>{{ item.secondary_text }}</md-highlight-text>
                                    </template>
                                </md-autocomplete>
                            </div>
                        </div>
                        <div class="assetsMapBtn_wrapper" v-if="showAssetsMapBtn"><div class="assetsMapBtn" @click="onAssetsMapBtnClick"><span>Assets map</span></div></div>
                        <b-form-checkbox class="airCompare_wrapper" v-model="showAirCompare" v-if="showAirCompareCheckbox">Show AirCompare</b-form-checkbox>
                        <b-form-checkbox class="airCompare_wrapper" v-model="mapOverlay.show" v-if="mapOverlay.showCheckbox">Show Assets</b-form-checkbox>
                        <b-form-checkbox class="airCompare_wrapper" v-model="mapBox.emptyBack.show" v-if="showAdminBlocks">Empty back</b-form-checkbox>
                        <div class="back-color color-white" v-if="showAdminBlocks && mapBox.emptyBack.show" @click="updateMapBack('#ffffff')"></div>
                        <div class="back-color color-pink" v-if="showAdminBlocks && mapBox.emptyBack.show" @click="updateMapBack('deeppink')"></div>
                    </div>
                </div>
        </div>
<!--		<div class="returnBtn-container">
			<div class="returnBtn__wrapper" @click="returnToMain">
				<div class="returnBtn__icon">
					<img src="@/assets/icons/Menager_back_arrow.svg">
				</div>
				<div class="returnBtn__text">{{translate('ReturnBtn')}}</div>
			</div>
		</div>-->
        <div id="map" class="map">
            <div class="votes_detailed_main_container collapsed"  id="votes_sidebar" @click.self="console.log('keke1')">
                <div class="votes_detailed_wrapper">
                    <div class="votes_detailed">
<!--                        <div class="votes_detailed_header">Votes in the selected area:</div>-->
                        <div class="votes_detailed_subheader_wrapper" v-if="votesSidebar.votes.length > 0">
                            <div class="votes_detailed_subheader">Total votes: {{ votesSidebar.votes.length }} (<span class="votes_happy">{{votesSidebar.stats.happy.count}}</span>&nbsp;<span class="votes_soso">{{votesSidebar.stats.soso.count}}</span>&nbsp;<span class="votes_sad">{{votesSidebar.stats.sad.count}}</span>)</div>
                            <div class="votes_detailed_subheader">Total locations: {{ votesSidebar.totalQuestions }}</div>
                            <div class="votes_detailed_cb"><b-form-checkbox v-model="votesSidebar.withDetailsOnly">Show with details only</b-form-checkbox></div>
                        </div>
                        <div class="votes_detailed_close" @click="onVotesSidebarCloseClick">Close</div>
                        <div class="votes_detailed_container">
                            <div class="votes_detailed_loading" v-if="votesSidebar.loading">Loading...</div>
                            <li v-for="item in votesSidebar.votesFiltered" class="votes_detailed_vote_wrapper"
                                :key="item.itemId"
                                :rate="item.rate">
                                <span class="date">{{item.date | moment("MMM D YYYY, h:mm a")}}</span>
                                <span class="map_link" v-if="shouldShowMapLink(item)"><a :href="getGeolocationGoogleMapLink(item)" target="_blank"><img src="@/assets/icons/ic_pin.svg"/></a></span>
                                <span class="question_id">#{{item.q_id}}</span>
                                <div v-if="item.placement || item.asset_id"><!--<span :class="`answer value-${item.rate}`" v-if="shouldShowAnswer(item)">{{item.answer}}</span>--><span class="placement" v-if="item.placement">{{item.placement}}</span><span class="placement" v-if="item.placement && item.asset_id"> | </span><span class="placement" v-if="item.asset_id">{{item.asset_id}}</span></div>
                                <p>{{item.comment}}</p>
                                <p v-if="item.contact_info"><i>{{item.contact_info}}</i></p>
                                <p v-if="item.attachments.audio"><audio controls :src="item.attachments.audio.audio_url" class="vote-audio"></audio></p>
                                <p v-if="item.sec_level.length > 0"><i>{{item.sec_level.join(', ')}}</i></p>

                                <div class="vd_attachments" v-if="item.attachments.images.length > 0">
                                    <img v-for="(item, index) in item.attachments.images"
                                         :key="index"
                                         :src="item.previewUrl"
                                         @click="onVoteImageClick(item)"/>
                                </div>
                            </li>
                        </div>
                    </div>
                </div>
            </div>
            <div class="votes_detailed_main_container collapsed"  id="asset_sidebar" @click.self="console.log('asset_sidebar click')">
                <div class="votes_detailed_wrapper">
                    <div class="votes_detailed">
                        <div class="asset_details_id" v-if="assetSidebar.question && assetSidebar.question.type.type != 'any'"><span class="">{{assetSidebar.question.type.name}}</span></div>
                        <div class="asset_details_id"><span class="asset_id">{{assetSidebar.asset_id}}</span> ({{assetSidebar.question_id}})</div>
                        <div class="asset_details_id" v-if="assetSidebar.question"><span class="">{{assetSidebar.question.placement}}</span></div>
                        <div class="asset_details_info">Updated on {{assetSidebar.dateFormatted}}{{assetSidebar.author}}</div>
                        <div class="votes_detailed_close" @click="closeAssetSidebar">Close</div>
                        <div class="asset_popup_btns">
                            <div class="link_btn" @click="onOpenAssetInGoogleClick">open in Google</div>
                            <div class="link_btn" @click="onShowLocationHistoryClick" v-if="this.assetSidebar.question && this.assetSidebar.question.has_history">show history</div>
                            <div class="link_btn fix-issue" @click="onFixLocationIssueClick" v-if="assetSidebar.question && assetSidebar.question.has_issue">fix location problem</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="votes_detailed_main_container collapsed"  id="set_gps_sidebar" @click.self="console.log('asset_sidebar click')">
                <div class="votes_detailed_wrapper">
                    <div class="votes_detailed">
                        <div class="set_gps_sidebar_title">Assign new geolocation</div>
                        <div v-if="this.setGPSSidebar.coordinates && this.setGPSSidebar.coordinates.lat != 0" class="sgs_map-preview">
                            <img :src="`https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/geojson(${this.setGPSSidebarStaticMapGeojson()})/${this.setGPSSidebar.coordinates.lng},${this.setGPSSidebar.coordinates.lat},17,0,0/400x200@2x?access_token=pk.eyJ1IjoiYWlydm90ZSIsImEiOiJjbHowNnVkNXoyM204Mmxxdm15cjN1OGU0In0.anyzHgjOH9rtxUTdp1oOJw&logo=false`">
                        </div>
                        <div class="set_gps_sidebar_toggle_wrapper">
<!--                            <div class="sgs_title">Find unit by:</div>-->
                            <div class="set_gps_sidebar_toggle_wrapper-toggles">
                                <div class="set_gps_sidebar_toggle_item" :class="{active: this.setGPSSidebar.type == 'question_id'}"
                                     @click="onSetGpsSidebarToggleTypeQuestionClick">AirVote ID</div>
                                <div class="set_gps_sidebar_toggle_item" :class="{active: this.setGPSSidebar.type == 'asset_id'}"
                                     @click="onSetGpsSidebarToggleTypeAssetIdClick">Asset ID</div>
                            </div>
                        </div>
                        <div class="set_gps_sidebar_qid_input_wrapper">
                            <md-field>
<!--                                <label>{{ this.setGPSSidebar.type == 'question_id' ? 'Question ID' : 'Asset ID' }}</label>-->
                                <md-input
                                    @input="onSetUnitGpsItemIdChanged"
                                    class="autocomplete"
                                    :type="this.setGPSSidebar.type == 'question_id' ? 'number' : 'text'"
                                    v-model="setGPSSidebar.item_id">
                                </md-input>
                            </md-field>
                        </div>
                        <div class="set_gps_sidebar_save" @click="onSetGpsSaveClick">Save</div>
                        <div class="votes_detailed_close" @click="closeSetGPSSidebar">Close</div>
<!--                        <div class="asset_popup_btns">
                            <div class="link_btn" @click="onOpenAssetInGoogleClick">open in Google</div>
                            <div class="link_btn" @click="onShowLocationHistoryClick" v-if="this.assetSidebar.question && this.assetSidebar.question.has_history">show history</div>
                            <div class="link_btn fix-issue" @click="onFixLocationIssueClick" v-if="assetSidebar.question && assetSidebar.question.has_issue">fix location problem</div>
                        </div>-->
                    </div>
                </div>
            </div>
            <div class="fc_wrapper leave"><div class="fc" @click="onLeaveFCModeClick">Leave fullscreen mode</div></div>
            <div class="fc_wrapper enter"><div class="fc" @click="onEnterFCModeClick">Enter fullscreen mode</div></div>
        </div>
        <div class="map_context_menu_popup_container">
            <div ref="map_context_menu_popup" class="map_context_menu_popup">
                <div class="menu-item" @click="onZoomToPointClick()">Zoom in here</div>
                <div class='menu-item' @click="onSetUnitGeolocationClick()">Set as unit geolocation</div>
            </div>
        </div>
        <div @click="onRefreshClick" class="refresh-btn">{{ translate('airLeadDashboardRefresh') }}</div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import customModalDialog from '@/components/widgets/customModalDialog';
import moment from 'moment'
import errorMixin from '@/mixins/errorMixin';
import CONSTANTS from '@/store/modules/serviceLog'
import datePicker from "vue-bootstrap-datetimepicker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import customModalMapDashboard from '@/components/widgets/customModalMapDashboard';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import MarkerClusterer from 'marker-clusterer-plus'
import PlaceMarkerInfoModal from '@/components/widgets/placeMarkerInfoModal'
import {Icon} from 'leaflet';
import {LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import 'leaflet/dist/leaflet.css';
import GoogleMapLoader from "@/components/GoogleMapLoader";
import GoogleMapMarker from "@/components/GoogleMapMarker";
import {mapSettings} from "@/constants/mapSettings";
import Multiselect from 'vue-multiselect'
import Spiderfy from '@nazka/map-gl-js-spiderfy';
import Verte from 'verte';
import 'verte/dist/verte.css';
import mapLocationHistory from "@/components/widgets/mapLocationHistory";
import mapFunctionsMixin from "@/mixins/mapFunctionsMixin";
import config from "@/api/config";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    name: 'mapDashboard',
    mixins: [mixin, errorMixin, mapFunctionsMixin, config],
    components: {
        InfiniteLoading,
        customModalDialog,
        datePicker,
        customModalMapDashboard,
        PlaceMarkerInfoModal,
        'gmap-custom-marker': GmapCustomMarker,
        MarkerClusterer,
        LMap,
        LTileLayer,
        LMarker,
        'v-marker-cluster': Vue2LeafletMarkerCluster,
        GoogleMapLoader,
        GoogleMapMarker,
        Multiselect,
        Verte,
        mapLocationHistory,
    },
    watch: {
        'votesSidebar.withDetailsOnly'(newValue) {
            this.refreshVotesSidebarFilters()
        },
        'showAirCompare'(newValue) {
            console.log(`showAirCompare changed: ${newValue}`)
            this.refreshAll()
        },
        'mapOverlay.show'(newValue) {
            console.log(`mapOverlay.show changed: ${newValue}`)
            this.onAssetsOverlayCheckChanged(newValue)
        },
        'mapBox.isSatelliteMode'(newValue) {
            console.log(`mapBox.isSatelliteMode changed: ${newValue}`)
            this.onMapModeChanged(newValue)
        },
    },
    data() {
        return {
            baseUrl: config.baseUrl,
            CONSTANTS: CONSTANTS,
            customModalSettings: {},
            mapLocationHistorySettings: {
                show: false,
            },
            dateFormat: moment.ISO_8601,
            dateRange: {
                type: 'last7days',
                dateFrom: null,
                dateTo: null,
            },
            dateRangeView: {
                dateFrom: null,
                dateTo: null,
                showDateFrom: false,
                showDateTo: false,
                options: {
                    format: 'MM/DD/YYYY H:mm',
                    useCurrent: false,
                    minDate: false,
                    maxDate: false,
                    keyBinds: false
                },
            },
            customModalMapDashboard: {
                show: false,
            },
            center: {
                lat: 41.539885146728,
                lng: -93.816014260418
            },
            zoom: 6,
            cases: [
                {options: {kek: 1}, latlng: {lat: 47, lng: 32}},
                {options: {kek: 2}, latlng: {lat: 47.01, lng: 32.02}},
                {options: {kek: 3}, latlng: {lat: 47.02, lng: 32.02}},
                {options: {kek: 4}, latlng: {lat: 47.01, lng: 32.03}},
                {options: {kek: 5}, latlng: {lat: 47.03, lng: 32.12}}
            ],
            items: [],
            geoJsonData: {},
            currentMapBoxData: {},
            assetsData: {},
            currentMapBoxAssetsData: {},
            mapBoxAssetsData: {},
            assetTypesTotal: 13,
            autocompleteAddressCollection: [],
            searchAddressQuery: '',
            showAssetsMapBtn: false,
            showAirCompare: false,
            showAirCompareCheckbox: false,
            markers: [
                {
                    id: "a",
                    position: { lat: 3, lng: 101 }
                },
                {
                    id: "b",
                    position: { lat: 5, lng: 99 }
                },
                {
                    id: "c",
                    position: { lat: 6, lng: 97 }
                }
            ],
            mapBoxMap: null,
            mapBoxMapBounds: null,
            isShowingAllItems: false,
            filterPlacement: '',
            filterSld: '',
            filterQId: '',
            mapBox: {
                needRefreshCache: true,
                firstRenderFinished: false,
                isSatelliteMode: false,
                emptyBack: {
                    show: false,
                    color: 'white'
                },
            },
            votesSidebar: {
                visible: false,
                votes: [],
                votesFiltered: [],
                loading: false,
                totalQuestions: 0,
                stats: {
                    happy: {},
                    soso: {},
                    sad: {},
                },
                withDetailsOnly: true,
            },
            assetSidebar: {
                visible: false,
                dateFormatted: '',
                asset_id: '',
                question_id: null,
                question: null,
                author: '',
                coordinates: {
                    lat: 0,
                    lng: 0,
                },
            },
            mapOverlay: {
                showCheckbox: true,
                show: false,
            },
            placesFilter: {
                selection: [],
                available: [],
            },
            showAdminBlocks: false,
            clustersSpiderfy: null,
            mapContextMenuPopup: null,
            setGPSSidebar: {
                visible: false,
                type: 'question_id',
                item_id: '',
                coordinates: {
                    lat: 0,
                    lng: 0,
                },
            },
            moveMapTo: null,
        }
    },
    computed: {
        ...mapState({
            accounts: state => state.closeAccount.accounts,
            userInfo: state => state.auth.userInfo,
        }),
        mapConfig() {
            return {
                ...mapSettings,
                center: this.mapCenter,
            };
        },

        mapCenter() {
            return this.markers[1].position;
        }
    },
    mounted() {
        // this.setupMapBoxMap()
        try {
            this.showAssetsMapBtn = this.userInfo.assets_map_access && this.userInfo.assets_map_access.has_access
            this.showAirCompareCheckbox = this.userInfo.org_ids && this.userInfo.org_ids.includes(251)
            this.mapBox.isSatelliteMode = this.userInfo.org_ids && this.userInfo.org_ids.includes(719)
            if(this.userInfo.org_ids && this.userInfo.org_ids.includes(719)) {
                this.mapOverlay.show = true
            }
            this.mapOverlay.showCheckbox = this.userInfo.assets_map_access && this.userInfo.assets_map_access.has_access
        }catch (e) {}
        this.parseDateRange()
        this.refreshAll()
        this.loadSites()
    },
    methods: {
        ...mapGetters({
            getOrgUid: 'auth/getOrgUid'
        }),
        ...mapActions({
            getMapReport: 'owner/getMapReport',
            getQuestionById: 'owner/getQuestionById',
            getMapReportGeoJson: 'owner/getMapReportGeoJson',
            getMapRatesReport: 'owner/getMapRatesReport',
            searchAddressAutocomplete: 'search/searchAddressAutocomplete',
            geocodeGooglePlaceId: 'search/geocodeGooglePlaceId',
            logUserAction: 'owner/logUserAction',
            getMapQuestionsGeoJson: 'owner/getMapQuestionsGeoJson',
            getAvailableSites: 'owner/getAvailableSites',
            fixLocationIssueForQuestionA: 'question/fixLocationIssueForQuestionA',
            assignGpsToQuestion: 'question/assignGpsToQuestion',
        }),

        ...mapMutations({
            setMessageModel: 'setMessageModel',
            setProgressBarTag: 'setProgressBarTag',
        }),


        setupMapBoxMap() {
            mapboxgl.accessToken = 'pk.eyJ1IjoiYWlydm90ZSIsImEiOiJjbGt2ZzU1M28wazQ1M2ZyMGwxdDN4d3puIn0.a-UUEX4p0wzUz8SSQ6SJ-g';
            if(this.mapBoxMap) {
                console.log(`has mapBoxMap`, this.mapBoxMap.getStyle().layers)
                // this.mapBoxMap.remove()
                // while (this.mapBoxMap.getStyle().layers.length > 0) {
                //     let layer = this.mapBoxMap.getStyle().layers[0]
                //     this.mapBoxMap.removeLayer(layer.id)
                // }
            }
            const map = new mapboxgl.Map({
                container: 'map',
                zoom: 0.3,
                center: [0, 20],
//                 style: 'mapbox://styles/mapbox/light-v11',
                style: this.getMapBoxStyle(),
//                 style: 'mapbox://styles/mapbox/satellite-v9',
//                 style: 'mapbox://styles/mapbox/satellite-streets-v12',
                projection: 'mercator',
                maxZoom: 22,
            });
            this.mapBoxMap = map
            let thiz = this

            class MapModeControl {
                onAdd(map){
                    this.map = map;
                    this.container = document.createElement('div');
                    let classMode = thiz.mapBox.isSatelliteMode ? 'default' : 'satellite'
                    this.container.className = `mapboxgl-ctrl mapboxgl-ctrl-group map-mode-btn ${classMode}`;
                    this.container.id = 'map_mode_btn';
                    this.container.addEventListener("click", () => {
                        thiz.onChangeMapModeClick()
                    });
                    return this.container;
                }
                onRemove(){
                    this.container.parentNode.removeChild(this.container);
                    this.map = undefined;
                }
            }
            document.querySelectorAll(".map-mode-btn").forEach(el => el.remove());
            const mapModeControl = new MapModeControl();
            map.addControl(new mapboxgl.NavigationControl());
            map.addControl(new mapboxgl.FullscreenControl());
            map.addControl(mapModeControl);

            const happy = ['>=', ['get', 'h'], 1];
            const soso = ['>=', ['get', 'g'], 1];
            const sad = ['>=', ['get', 's'], 1];

            const hasIssue = ['==', ['get', 'i'], 1];
            const typeAny = ['==', ['get', 't'], 0];
            const typeAnyIssue = ['all', typeAny, hasIssue]
            const typePortableToilet = ['==', ['get', 't'], 1];
            const typePortableToiletIssue = ['all', typePortableToilet, hasIssue]
            const typeTrailer = ['==', ['get', 't'], 2];
            const typeTrailerIssue = ['all', typeTrailer, hasIssue]
            const typeTrailerStall = ['==', ['get', 't'], 3];
            const typeTrailerStallIssue = ['all', typeTrailerStall, hasIssue]
            const typeGreasetrap = ['==', ['get', 't'], 4];
            const typeGreasetrapIssue = ['all', typeGreasetrap, hasIssue]
            const typeInterceptor = ['==', ['get', 't'], 5];
            const typeInterceptorIssue = ['all', typeInterceptor, hasIssue]
            const typeDumpster = ['==', ['get', 't'], 6];
            const typeDumpsterIssue = ['all', typeDumpster, hasIssue]
            const typeSink = ['==', ['get', 't'], 7];
            const typeSinkIssue = ['all', typeSink, hasIssue]
            const typeTank = ['==', ['get', 't'], 8];
            const typeTankIssue = ['all', typeTank, hasIssue]
            const typeVending = ['==', ['get', 't'], 9];
            const typeVendingIssue = ['all', typeVending, hasIssue]
            const typeRestroom = ['==', ['get', 't'], 10];
            const typeRestroomIssue = ['all', typeRestroom, hasIssue]
            const typeRestroomStall = ['==', ['get', 't'], 11];
            const typeRestroomStallIssue = ['all', typeRestroomStall, hasIssue]
            const typeTable = ['==', ['get', 't'], 12];
            const typeTableIssue = ['all', typeTable, hasIssue]
            const typeShower = ['==', ['get', 't'], 13];
            const typeShowerIssue = ['all', typeShower, hasIssue]
            let markerImages = {
                0: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, -5.5], leavesOffset: [0, 0]},
                1: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, -5.5], leavesOffset: [0, -65]},
                2: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                3: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                4: {single: 'greasetrap_lbl', cluster: 'greasetrap_cluster', clusterLeaf: 'greasetrap_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                5: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                6: {single: 'dumpster_lbl', cluster: 'dumpster_cluster', clusterLeaf: 'dumpster_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                7: {single: 'handwash_lbl', cluster: 'handwash_cluster', clusterLeaf: 'handwash_leaf', clusterTextOffset: [0, -5.5], leavesOffset: [0, -65]},
                8: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                9: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                10: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                11: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
                12: {single: 'asset_blue_lbl', cluster: 'asset_blue_cluster', clusterLeaf: 'asset_leaf', clusterTextOffset: [0, 0], leavesOffset: [0, 0]},
            }

            const clusterHasIssue = ['>=', ['get', 'has_issue'], 1];
            const hasSpecificNotPortableType =
                [
                    'any',
                    ['>=', ['get', '0'], 1],
                    ['>=', ['get', '2'], 1],
                    ['>=', ['get', '3'], 1],
                    ['>=', ['get', '4'], 1],
                    ['>=', ['get', '5'], 1],
                    ['>=', ['get', '6'], 1],
                    ['>=', ['get', '7'], 1],
                    ['>=', ['get', '8'], 1],
                    ['>=', ['get', '9'], 1],
                    ['>=', ['get', '10'], 1],
                    ['>=', ['get', '11'], 1],
                    ['>=', ['get', '12'], 1],
                    ['>=', ['get', '13'], 1],
                ];
            const hasSpecificNotPortableTypeWithIssue = ['all', hasSpecificNotPortableType, clusterHasIssue]
            const hasOnlyDumpsterType =
                [
                    'all',
                    ['==', ['get', '0'], 0],
                    ['==', ['get', '1'], 0],
                    ['==', ['get', '2'], 0],
                    ['==', ['get', '3'], 0],
                    ['==', ['get', '4'], 0],
                    ['==', ['get', '5'], 0],
                    ['>=', ['get', '6'], 1],
                    ['==', ['get', '7'], 0],
                    ['==', ['get', '8'], 0],
                    ['==', ['get', '9'], 0],
                    ['==', ['get', '10'], 0],
                    ['==', ['get', '11'], 0],
                    ['==', ['get', '12'], 0],
                    ['==', ['get', '13'], 0],
                ];
            const hasOnlyDumpsterTypeWithIssue = ['all', hasOnlyDumpsterType, clusterHasIssue]
            const hasOnlyGreasetrapType =
                [
                    'all',
                    ['==', ['get', '0'], 0],
                    ['==', ['get', '1'], 0],
                    ['==', ['get', '2'], 0],
                    ['==', ['get', '3'], 0],
                    ['>=', ['get', '4'], 1],
                    ['==', ['get', '5'], 0],
                    ['==', ['get', '6'], 0],
                    ['==', ['get', '7'], 0],
                    ['==', ['get', '8'], 0],
                    ['==', ['get', '9'], 0],
                    ['==', ['get', '10'], 0],
                    ['==', ['get', '11'], 0],
                    ['==', ['get', '12'], 0],
                    ['==', ['get', '13'], 0],
                ];
            const hasOnlyGreasetrapTypeWithIssue = ['all', hasOnlyGreasetrapType, clusterHasIssue]
            const hasOnlyHandwashType =
                [
                    'all',
                    ['==', ['get', '0'], 0],
                    ['==', ['get', '1'], 0],
                    ['==', ['get', '2'], 0],
                    ['==', ['get', '3'], 0],
                    ['==', ['get', '4'], 0],
                    ['==', ['get', '5'], 0],
                    ['==', ['get', '6'], 0],
                    ['>=', ['get', '7'], 1],
                    ['==', ['get', '8'], 0],
                    ['==', ['get', '9'], 0],
                    ['==', ['get', '10'], 0],
                    ['==', ['get', '11'], 0],
                    ['==', ['get', '12'], 0],
                    ['==', ['get', '13'], 0],
                ];
            const hasOnlyHandwashTypeWithIssue = ['all', hasOnlyHandwashType, clusterHasIssue]
            const hasOnlyTankType =
                [
                    'all',
                    ['==', ['get', '0'], 0],
                    ['==', ['get', '1'], 0],
                    ['==', ['get', '2'], 0],
                    ['==', ['get', '3'], 0],
                    ['==', ['get', '4'], 0],
                    ['==', ['get', '5'], 0],
                    ['==', ['get', '6'], 0],
                    ['==', ['get', '7'], 0],
                    ['>=', ['get', '8'], 1],
                    ['==', ['get', '9'], 0],
                    ['==', ['get', '10'], 0],
                    ['==', ['get', '11'], 0],
                    ['==', ['get', '12'], 0],
                    ['==', ['get', '13'], 0],
                ];
            const hasOnlyTankTypeWithIssue = ['all', hasOnlyTankType, clusterHasIssue]
            const hasOnlyTrailerType =
                [
                    'all',
                    ['==', ['get', '0'], 0],
                    ['==', ['get', '1'], 0],
                    ['>=', ['get', '2'], 1],
                    ['==', ['get', '3'], 0],
                    ['==', ['get', '4'], 0],
                    ['==', ['get', '5'], 0],
                    ['==', ['get', '6'], 0],
                    ['==', ['get', '7'], 0],
                    ['==', ['get', '8'], 0],
                    ['==', ['get', '9'], 0],
                    ['==', ['get', '10'], 0],
                    ['==', ['get', '11'], 0],
                    ['==', ['get', '12'], 0],
                    ['==', ['get', '13'], 0],
                ];
            const hasOnlyTrailerTypeWithIssue = ['all', hasOnlyTrailerType, clusterHasIssue]

            const colors = ['#5db364', '#ffa846', '#d53f3a', '#ffffff'];

            loadImages()
            map.on('load', () => {
                map.getCanvas().style.cursor = 'pointer';
                map.on('mouseenter', `asset_item_cluster`, () => {
                    map.getCanvas().style.cursor = 'pointer';
                });
                map.on('mouseleave', `asset_item_cluster`, () => {
                    map.getCanvas().style.cursor = 'pointer';//'' for default
                });
                map.on('mouseenter', `asset_item_lbl`, () => {
                    map.getCanvas().style.cursor = 'pointer';
                });
                map.on('mouseleave', `asset_item_lbl`, () => {
                    map.getCanvas().style.cursor = 'pointer'; //'' for default
                });

                map.on('click', 'asset_item_lbl', (e) => {
                    console.log(`asset_item_lbl click`, e)
                    if (e.originalEvent.clickOnLayer) {
                        return;
                    }
                    this.showAssetSidebar(e.features[0])
                });
                map.on('click', 'asset_item_cluster', (e) => {
                    console.log(`asset_item_cluster click`, e)
                    thiz.closeAssetSidebar()
                    thiz.closeVotesSidebar()
                });
                map.on('contextmenu', function(e) {
                    console.log('contextmenu show', e);
                    thiz.showContextMenu(e)
                });
                map.on('movestart', function(e) {
                    console.log('movestart', e);
                    // thiz.closeMapContextMenuPopup()
                });
                map.on('click', function (e) {
                    console.log(`map click`, e)
                    // thiz.showContextMenu(e)
                });
                console.log(`MAP LOADED`)
                map.resize()
                setupMap()


// objects for caching and keeping track of HTML marker objects (for performance)
                let markers = {};
                let markersOnScreen = {};

                let markersSingle = {};
                let markersSingleOnScreen = {};

                function updateMarkers() {
                    const newMarkers = {};
                    const features = map.querySourceFeatures('votes_points');

// for every cluster on the screen, create an HTML marker for it (if we didn't yet),
// and add it to the map if it's not there already
                    for (const feature of features) {
                        const coords = feature.geometry.coordinates;
                        const props = feature.properties;
                        if (!props.cluster) continue;
                        const id = props.cluster_id;

                        let marker = markers[id];
                        if (!marker) {
                            const el = createDonutChart(props, 'white');
                            marker = markers[id] = new mapboxgl.Marker({
                                element: el
                            }).setLngLat(coords);
                            el.addEventListener('click', (e) =>
                                {
                                    // console.log(`cluster clicked?2`, e)
                                    // console.log(`cluster clicked?3`, e.point)
                                    // console.log(`cluster clicked?props`, props)
                                    // console.log(`cluster clicked? point_count`, props.point_count)
                                    let totalVotes = 0
                                    if(props.h) totalVotes+=props.h
                                    if(props.g) totalVotes+=props.g
                                    if(props.s) totalVotes+=props.s
                                    let clusterSource = map.getSource('votes_points');
                                    console.log('getClusterLeaves!!', props.cluster_id);
                                    clusterSource.getClusterLeaves(props.cluster_id, props.point_count, 0, function(err, features){
                                        console.log('getClusterLeaves', err, features);
                                        if(totalVotes > 300 && features.length > 1) {
                                            const point = {
                                                center: coords,
                                                zoom: map.getZoom() + 2,
                                                // bearing: 130,
                                                // pitch: 75,
                                                duration: 1000,
                                                essential: true,
                                            };
                                            console.log('fly map to', point);
                                            thiz.closeVotesSidebar()
                                            thiz.closeAssetSidebar()
                                            map.flyTo(point);
                                        } else {
                                            thiz.showVotesSidebar(features)
                                        }
                                        // throw '!!!'

                                    })
                                }
                            );
                        }
                        newMarkers[id] = marker;

                        if (!markersOnScreen[id]) marker.addTo(map);
                    }
// for every marker we've added previously, remove those that are no longer visible
                    for (const id in markersOnScreen) {
                        if (!newMarkers[id]) markersOnScreen[id].remove();
                    }
                    markersOnScreen = newMarkers;
                }
                function updateSingleMarkers() {
                    const newMarkers = {};
                    const features = map.querySourceFeatures('votes_points');

                    for (const feature of features) {
                        const coords = feature.geometry.coordinates;
                        const props = feature.properties;
                        if (props.cluster) continue;
                        if (props.h == 0 && props.g == 0 && props.s == 0) continue;
                        // const id = props.id;
                        const id = `${coords[0]}${coords[1]}${props.h}${props.g}${props.s}`;

                        // console.log(`qwerty:`, props)
                        let marker = markersSingle[id];
                        if (!marker) {
                            const el = createDonutChart(props, '#fff8d9');
                            marker = markersSingle[id] = new mapboxgl.Marker({
                                element: el,
                                // offset: [0, -45]
                            }).setLngLat(coords);
                            el.addEventListener('click', (e) =>
                                {
                                    console.log('donutchar addEventListener', e)
                                    thiz.showVotesSidebar([feature])
                                    e.clickOnLayer = true;
                                }
                            );
                        }
                        newMarkers[id] = marker;

                        if (!markersSingleOnScreen[id]) marker.addTo(map);
                    }
// for every marker we've added previously, remove those that are no longer visible
                    for (const id in markersSingleOnScreen) {
                        if (!newMarkers[id]) markersSingleOnScreen[id].remove();
                    }
                    markersSingleOnScreen = newMarkers;
                }

// after the GeoJSON data is loaded, update markers on the screen on every frame
                map.on('render', () => {
                    // console.log(`map.on('render') thiz.firstRenderFinished: ${thiz.mapBox.firstRenderFinished}`)
                    if (!map.isSourceLoaded('votes_points')) return;
                    // console.log(`map.on('render') continue`)
                    if(thiz.mapBox.needRefreshCache) {
                        for (const id in markers) { markers[id].remove() }
                        for (const id in markersSingle) { markersSingle[id].remove() }
                        markers = {}
                        markersOnScreen = {}
                        markersSingle = {}
                        markersSingleOnScreen = {}
                        thiz.mapBox.needRefreshCache = false
                        // console.log(`map.on('render') refresh cache`)
                    }
                    updateMarkers();
                    updateSingleMarkers();

                    if(!thiz.mapBox.firstRenderFinished) {
                        thiz.mapBox.firstRenderFinished = true
                        thiz.fitMapToMarkersBounds()
                    }
                });
                // map.on('click', function (e) {
                //     console.log(`map click: 1`)
                //     console.log(`map click features`, e)
                //     // console.log(`cluster click layers:`, map.getStyle().layers)
                // });
                // map.on('click', 'earthquake_circle', function (e) {
                //     console.log(`earthquake_circle click`, e)
                //     console.log(`earthquake_circle features`, e.features[0])
                //     thiz.showVotesSidebar([e.features[0]])
                // });
                // map.on('click', 'earthquake_label', function (e) {
                //     console.log(`earthquake_label click`, e)
                //     console.log(`earthquake_label features`, e.features[0])
                //     thiz.showVotesSidebar([e.features[0]])
                // });
            });
            map.on('style.load', () => {
                console.log(`on styledata called!!!!!!!!!!!!!!`)
                if(!map.getSource('assets_points')) {
                    setupMap()
                }
            })
            // code for creating an SVG donut chart from feature properties
            function setupMap() {
                loadImages()
                if(!map.getSource('votes_points')) {
                    map.addSource('votes_points', {
                        'type': 'geojson',
                        'data': thiz.currentMapBoxData,
                        'cluster': true,
                        'clusterRadius': 50,
                        'clusterMaxZoom': 18,
                        'clusterProperties': {
                            'h': ['+', ['case', happy, ['get', 'h'], 0]],
                            'g': ['+', ['case', soso, ['get', 'g'], 0]],
                            's': ['+', ['case', sad, ['get', 's'], 0]],
                        }
                    });
                }

// circle and symbol layers for rendering individual earthquakes (unclustered points)
                if(!map.getLayer('earthquake_circle')) {
                    map.addLayer({
                        'id': 'earthquake_circle',
                        'type': 'circle',
                        'source': 'votes_points',
                        'filter': ['!=', 'cluster', true],
                        'paint': {
                            'circle-color': [
                                'case',
                                happy,
                                colors[0],
                                soso,
                                colors[1],
                                sad,
                                colors[2],
                                colors[3],
                            ],
                            'circle-opacity': 0.3,
                            'circle-radius': 20,
                            // 'circle-translate': [0, -5],
                        },
                    });
                }
                //label of the specific marker
                if(!map.getLayer('earthquake_label')) {
                    map.addLayer({
                        'id': 'earthquake_label',
                        'type': 'symbol',
                        'source': 'votes_points',
                        'filter': ['!=', 'cluster', true],
                        'layout': {
                            'text-field': [
                                'format',
                                // ['get', 'mag'],
                                ['case',
                                    happy,
                                    'happy',
                                    soso,
                                    'soso',
                                    sad,
                                    'sad',
                                    'No\nvotes',],
                            ],
                            // 'text-field': [
                            //     'number-format',
                            //     // ['get', 'mag'],
                            //     ['case',
                            //         happy,
                            //         111,
                            //         soso,
                            //         222,
                            //         sad,
                            //         333,
                            //         0,],
                            //     // 998877,
                            //     { 'min-fraction-digits': 1, 'max-fraction-digits': 1 }
                            // ],
                            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                            'text-size': 10
                        },
                        'paint': {
                            'text-color': [
                                'case',
                                happy,
                                'white',
                                soso,
                                'white',
                                sad,
                                'white',
                                'black',
                            ],
                            // 'text-color': [
                            //     'case',
                            //     ['>', ['get', 'h'], 0],
                            //     'white',
                            //     'yellow'
                            // ]
                        }
                    });
                }

                // ___
                if(!map.getSource('assets_points')) {
                    map.addSource('assets_points', {
                        'type': 'geojson',
                        'data': thiz.currentMapBoxAssetsData,
                        'cluster': true,
                        'clusterRadius': 50,
                        'clusterMaxZoom': 18,
                        'clusterProperties': {
                            '0': ['+', ['case', typeAny, 1, 0]],
                            '1': ['+', ['case', typePortableToilet, 1, 0]],
                            '2': ['+', ['case', typeTrailer, 1, 0]],
                            '3': ['+', ['case', typeTrailerStall, 1, 0]],
                            '4': ['+', ['case', typeGreasetrap, 1, 0]],
                            '5': ['+', ['case', typeInterceptor, 1, 0]],
                            '6': ['+', ['case', typeDumpster, 1, 0]],
                            '7': ['+', ['case', typeSink, 1, 0]],
                            '8': ['+', ['case', typeTank, 1, 0]],
                            '9': ['+', ['case', typeVending, 1, 0]],
                            '10': ['+', ['case', typeRestroom, 1, 0]],
                            '11': ['+', ['case', typeRestroomStall, 1, 0]],
                            '12': ['+', ['case', typeTable, 1, 0]],
                            '13': ['+', ['case', typeShower, 1, 0]],
                            'has_issue': ['+', ['case', hasIssue, 1, 0]],
                        }
                    });
                }
                if(!map.getLayer('asset_item_lbl')) {
                    map.addLayer({
                        'id': 'asset_item_lbl',
                        'type': 'symbol',
                        'icon-allow-overlap': true,
                        'text-allow-overlap': true,
                        'source': 'assets_points',
                        'filter': ['!=', 'cluster', true],
                        'layout': {
                            'icon-image': ['case',
                                typeDumpsterIssue,
                                'dumpster_lbl_issue',
                                typeDumpster,
                                'dumpster_lbl',
                                typeGreasetrapIssue,
                                'greasetrap_lbl_issue',
                                typeGreasetrap,
                                'greasetrap_lbl',
                                typeSinkIssue,
                                'handwash_lbl_issue',
                                typeSink,
                                'handwash_lbl',
                                typeTrailerIssue,
                                'trailer_lbl_issue',
                                typeTrailer,
                                'trailer_lbl',
                                typeTankIssue,
                                'tank_lbl_issue',
                                typeTank,
                                'tank_lbl',
                                typeInterceptorIssue,
                                'greasetrap_lbl_issue',
                                typeInterceptor,
                                'greasetrap_lbl',
                                typePortableToiletIssue,
                                'asset_blue_lbl_issue',
                                typePortableToilet,
                                'asset_blue_lbl',
                                typeAnyIssue,
                                'generic_lbl_issue',
                                'generic_lbl',],
                            'icon-text-fit': 'both',
                            // 'icon-size': 0.3,
                            // 'icon-anchor': 'bottom',
                            'text-field': [
                                'format',
                                // ['image', 'asset_blue_lbl'],
                                // '\n',
                                // ['literal', 'sdfasd'],
                                ['get', 'a_id'],
                                // ['literal', 'sdfasd']
                            ],
                            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                            'text-size': 13,
                            'text-anchor': 'center',
                            'text-offset': [0, -5.5],
                        },
                        // paint: {
                        //     "text-color": "#000000",
                        //     "text-halo-color": "#2D59A2",
                        //     "text-halo-width": 2,
                        // }
                    });
                }
                if(!map.getLayer('asset_item_cluster')) {
                    map.addLayer({
                        'id': 'asset_item_cluster',
                        'type': 'symbol',
                        'icon-allow-overlap': true,
                        'text-allow-overlap': true,
                        'source': 'assets_points',
                        // 'filter': ['==', 'cluster', true],
                        filter: ['has', 'point_count'],
                        'layout': {
                            // 'icon-image': 'asset_blue_cluster',
                            'icon-image': ['case',
                                hasOnlyDumpsterTypeWithIssue,
                                'dumpster_cluster_issue',
                                hasOnlyDumpsterType,
                                'dumpster_cluster',
                                hasOnlyGreasetrapTypeWithIssue,
                                'greasetrap_cluster_issue',
                                hasOnlyGreasetrapType,
                                'greasetrap_cluster',
                                hasOnlyHandwashTypeWithIssue,
                                'handwash_cluster_issue',
                                hasOnlyHandwashType,
                                'handwash_cluster',
                                hasOnlyTankTypeWithIssue,
                                'tank_cluster_issue',
                                hasOnlyTankType,
                                'tank_cluster',
                                hasOnlyTrailerTypeWithIssue,
                                'trailer_cluster_issue',
                                hasOnlyTrailerType,
                                'trailer_cluster',
                                hasSpecificNotPortableTypeWithIssue,
                                'generic_cluster_issue',
                                hasSpecificNotPortableType,
                                'generic_cluster',
                                clusterHasIssue,
                                'asset_blue_cluster_issue',
                                'asset_blue_cluster',],
                            'icon-text-fit': 'both',
                            // 'icon-size': 0.3,
                            // 'icon-anchor': 'bottom',
                            'text-field': [
                                'format',
                                // ['literal', 'sdfasd'],
                                ['get', 'point_count'],
                                // ['literal', 'sdfasd']
                            ],
                            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                            'text-size': 13,
                            'text-anchor': 'center',
                            'text-offset': [0, -0.5],
                        },
                        paint: {
                            "text-color": "#ffffff",
                            // "text-halo-color": "#2D59A2",
                            // "text-halo-width": 2,
                        }
                    });
                }
                let imageConfig = markerImages[6]
                let clusterLayout = {
                    'icon-allow-overlap': true,
                    'text-allow-overlap': true,
                    // 'icon-image': imageConfig.cluster,
                    'icon-image': ['case',
                        typeSinkIssue,
                        'handwash_leaf_issue',
                        typeSink,
                        'handwash_leaf',
                        typeDumpsterIssue,
                        'dumpster_leaf_issue',
                        typeDumpster,
                        'dumpster_leaf',
                        typeTankIssue,
                        'tank_leaf_issue',
                        typeTank,
                        'tank_leaf',
                        typeGreasetrapIssue,
                        'greasetrap_leaf_issue',
                        typeGreasetrap,
                        'greasetrap_leaf',
                        typeInterceptorIssue,
                        'greasetrap_leaf_issue',
                        typeInterceptor,
                        'greasetrap_leaf',
                        typeTrailerIssue,
                        'trailer_leaf_issue',
                        typeTrailer,
                        'trailer_leaf',
                        typePortableToiletIssue,
                        'asset_leaf_issue',
                        typePortableToilet,
                        'asset_leaf',
                        typeAnyIssue,
                        'generic_leaf_issue',
                        'generic_leaf',],
                    'icon-text-fit': 'both',
                    // 'icon-size': 0.3,
                    // 'icon-anchor': 'bottom',
                    'text-field': [
                        'format',
                        // ['literal', 'sdfasd'],
                        ['get', 'point_count'],
                        // ['literal', 'sdfasd']
                    ],
                    'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                    'text-size': 13,
                    'text-anchor': 'center',
                    'text-offset': imageConfig.clusterTextOffset,
                }
                // clusterLayout['icon-image'] = imageConfig.clusterLeaf
                clusterLayout['text-field'] = ['format', ['get', 'a_id'],]
                clusterLayout['text-offset'] = [0, 0]
                if(thiz.clustersSpiderfy) {
                    thiz.clustersSpiderfy.map = null
                }
                const spiderfy = new Spiderfy(map, {
                    onLeafClick: e => {
                        console.log('onLeafClick')
                        console.log(e)
                        thiz.showAssetSidebar(e)
                        throw '???'
                    },
                    minZoomLevel: 19,
                    zoomIncrement: 3,
                    spiderLegsAreHidden: false,
                    renderMethod: '3D',
                    circleOptions: {
                        leavesSeparation: 130,
                        leavesOffset: imageConfig.leavesOffset,
                    },
                    circleSpiralSwitchover: 5,
                    spiralOptions: {
                        legLengthStart: 100,
                        legLengthFactor: 8,
                        leavesSeparation: 130,
                        leavesOffset: imageConfig.leavesOffset,
                    },
                    spiderLeavesLayout: clusterLayout,
                    spiderLeavesPaint: {
                        // 'icon-color': [
                        //     'match',
                        //     ['get', 'wheelchair'],
                        //     'yes',
                        //     'green',
                        //     /* other */ 'red'
                        // ],
                    },
                });
                spiderfy.applyTo(`asset_item_cluster`)
                thiz.clustersSpiderfy = spiderfy
            }

            function loadImages() {
                thiz.loadMapImages(map, true)
            }

            function createDonutChart(props, fill) {
                const offsets = [];
                const counts = [
                    props.h,
                    props.g,
                    props.s,
                ];
                let total = 0;
                for (const count of counts) {
                    offsets.push(total);
                    total += count;
                }
                const fontSize =
                    total >= 1000 ? 22 : total >= 100 ? 20 : total >= 10 ? 18 : 16;
                const r =
                    total >= 1000 ? 50 : total >= 100 ? 32 : total >= 10 ? 24 : 18;
                const r0 = Math.round(r * 0.6);
                const w = r * 2;

                let html = `<div>
<svg width="${w}" height="${w}" viewbox="0 0 ${w} ${w}" text-anchor="middle" style="font: ${fontSize}px sans-serif; display: block">`;

                for (let i = 0; i < counts.length; i++) {
                    html += donutSegment(
                        offsets[i] / total,
                        (offsets[i] + counts[i]) / total,
                        r,
                        r0,
                        colors[i]
                    );
                }
                html += `<circle cx="${r}" cy="${r}" r="${r0}" fill="${fill}" />
<text dominant-baseline="central" transform="translate(${r}, ${r})">
${total.toLocaleString()}
</text>
</svg>
</div>`;

                const el = document.createElement('div');
                el.innerHTML = html;
                return el.firstChild;
            }

            function donutSegment(start, end, r, r0, color) {
                if (end - start === 1) end -= 0.00001;
                const a0 = 2 * Math.PI * (start - 0.25);
                const a1 = 2 * Math.PI * (end - 0.25);
                const x0 = Math.cos(a0),
                    y0 = Math.sin(a0);
                const x1 = Math.cos(a1),
                    y1 = Math.sin(a1);
                const largeArc = end - start > 0.5 ? 1 : 0;

// draw an SVG path
                return `<path d="M ${r + r0 * x0} ${r + r0 * y0} L ${r + r * x0} ${
                    r + r * y0
                } A ${r} ${r} 0 ${largeArc} 1 ${r + r * x1} ${r + r * y1} L ${
                    r + r0 * x1
                } ${r + r0 * y1} A ${r0} ${r0} 0 ${largeArc} 0 ${r + r0 * x0} ${
                    r + r0 * y0
                }" fill="${color}" />`;
            }
        },

        parseDateRange() {
            let dateFormat = this.dateFormat
            let dateRange = this.$route.query.date_type
            // let rangeFrom = moment("2015-06-22T13:17:21+0000", dateFormat, true).isValid()
            let rangeFrom = moment(this.$route.query.from, dateFormat, true).isValid() ? this.$route.query.from : null
            let rangeTo = moment(this.$route.query.to, dateFormat, true).isValid() ? this.$route.query.to : null

            if (rangeFrom != null && rangeTo != null) {
                dateRange = CONSTANTS.CUSTOM
                this.dateRange.dateFrom = rangeFrom
                this.dateRange.dateTo = rangeTo
            } else {
                switch (dateRange) {
                    case CONSTANTS.TODAY: {
                        break;
                    }
                    case CONSTANTS.LAST7DAYS: {
                        break;
                    }
                    case CONSTANTS.ALL_TIME: {
                        break;
                    }
                    case CONSTANTS.CUSTOM: {
                        dateRange = CONSTANTS.LAST7DAYS
                        //todo show error parsing date parameters if needed?
                        break;
                    }
                    default: {
                        dateRange = CONSTANTS.LAST7DAYS
                    }
                }
            }
            this.dateRange.type = dateRange
            this.updateDateParams()
        },
        isDateRangeAllTime() {
            return this.dateRange.type == CONSTANTS.ALL_TIME
        },
        getDateRangeTypeTranslation() {
            let str = ''
            switch (this.dateRange.type) {
                case CONSTANTS.TODAY: {
                    str = 'own_today'
                    break;
                }
                case CONSTANTS.LAST7DAYS: {
                    str = 'own_last7days'
                    break;
                }
                case CONSTANTS.ALL_TIME: {
                    str = 'own_allTime'
                    break;
                }
                case CONSTANTS.CUSTOM: {
                    str = 'own_custom'
                    break;
                }
            }
            return this.translate(str)
        },
        onDateTypeClick(type) {
            let oldRange = this.dateRange.type
            if (oldRange == type) return
            this.dateRange.type = type
            if (type == CONSTANTS.CUSTOM) {
                switch (oldRange) {
                    case CONSTANTS.TODAY: {
                        this.dateRange.dateFrom = moment().startOf('day').toISOString(true)
                        this.dateRange.dateTo = moment().endOf('day').toISOString(true)
                        break;
                    }
                    case CONSTANTS.LAST7DAYS: {
                        console.log('kek lol')
                        this.dateRange.dateFrom = moment().subtract(7, 'days').startOf('day').toISOString(true)
                        this.dateRange.dateTo = moment().endOf('day').toISOString(true)
                        break;
                    }
                    case CONSTANTS.ALL_TIME: {
                        this.dateRange.dateFrom = moment().startOf('day').toISOString(true)
                        this.dateRange.dateTo = moment().endOf('day').toISOString(true)
                        break;
                    }
                }
            } else {
                this.dateRange.dateFrom = null
                this.dateRange.dateTo = null
            }
            this.updateDateParams()
            this.refreshAll()
        },

        updateDateParams() {
            this.updateRangeViewFromRange()
            let query = JSON.parse(JSON.stringify(this.$route.query))
            delete query['from']
            delete query['to']
            query.date_type = this.dateRange.type
            if (this.dateRange.dateFrom) query.from = this.dateRange.dateFrom
            if (this.dateRange.dateTo) query.to = this.dateRange.dateTo
            this.$router.replace({
                path: this.$route.path, query: query
            })
        },
        onDatePickerHidden() {
            this.refreshAll()
            this.dateRangeView.showDateFrom = false;
            this.dateRangeView.showDateTo = false;
        },
        updateRangeViewFromRange() {
            if (this.dateRange.dateFrom && this.dateRange.dateTo) {
                this.dateRangeView.dateFrom = moment(this.dateRange.dateFrom).format(this.dateRangeView.options.format)
                this.dateRangeView.dateTo = moment(this.dateRange.dateTo).format(this.dateRangeView.options.format)
            }
        },
        onDateFromChanged() {
            if (this.dateRangeView.dateFrom) {
                this.dateRange.dateFrom = moment(this.dateRangeView.dateFrom, this.dateRangeView.options.format).toISOString(true)
                this.updateDateParams()
            }
        },
        onDateToChanged() {
            if (this.dateRangeView.dateTo) {
                this.dateRange.dateTo = moment(this.dateRangeView.dateTo, this.dateRangeView.options.format).toISOString(true)
                this.updateDateParams()
            }
        },
        onRefreshClick() {
            this.refreshAll()
        },
        reclusterItems() {
            this.$refs.clusterRef.mapObject.refreshClusters()
        },
        fitMapToMarkersBounds() {
            if(this.mapBoxMap) {
                this.mapBoxMap.fitBounds(this.mapBoxMapBounds, {
                    padding: 100,
                });
            }
        },
        onAssetsOverlayCheckChanged(newValue) {
            if(newValue) {
                this.refreshQuestionsGps()
            } else {
                this.clearAssetsOnTheMap()
            }
        },
        onMapModeChanged(isSatellite) {
            if(this.mapBoxMap) {
                // let style = isSatellite ? 'mapbox://styles/mapbox/satellite-streets-v12' : 'mapbox://styles/mapbox/streets-v12'
                let style = this.getMapBoxStyle()
                this.mapBoxMap.setStyle(style)
            }
            let mapModeBtn = document.getElementById('map_mode_btn')
            let mapModeBtns = document.getElementsByClassName('map-mode-btn')
            if(mapModeBtns) {
                let classMode = this.mapBox.isSatelliteMode ? 'default' : 'satellite'
                mapModeBtns.forEach(item => {
                    item.classList.remove('satellite')
                    item.classList.remove('default')
                    item.classList.add(classMode)
                })
            }

        },
        updateMapStyle() {
            if(this.mapBox.emptyBack.show) {
                this.refreshAll()
            } else {
                let style = this.getMapBoxStyle()
                this.mapBoxMap.setStyle(style)
            }
        },
        updateMapBack(color) {
            this.mapBox.emptyBack.color = color
            this.refreshAll()
        },
        getMapBoxStyle() {
            if (this.mapBox.emptyBack.show) {
                return {
                    "version": 8,
                    "name": "Empty",
                    "glyphs": "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
                    "sources": {},
                    "layers": [
                        {
                            "id": "background",
                            "type": "background",
                            "paint": {
                                "background-color": this.mapBox.emptyBack.color,
                            }
                        }
                    ]
                }
            } else {
                return this.mapBox.isSatelliteMode ? 'mapbox://styles/mapbox/satellite-v9' : 'mapbox://styles/mapbox/streets-v12'
            }
        },
        async loadSites() {
            try {
                const response = await this.getAvailableSites()
                this.placesFilter.available = response.collection
                this.placesFilter.selection = response.collection.filter((place) => {
                    return place.has_votes
                })
                if(this.placesFilter.selection.length == 0) {
                    this.placesFilter.selection = this.placesFilter.available
                }
            } catch (e) {
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {

            }
        },
        prepareRequestData() {
            const apiDateFormat = "YYYY-MM-DD HH:mm:ss"
            let data = {}
            switch (this.dateRange.type) {
                case CONSTANTS.TODAY: {
                    data.date_from_local = moment().startOf('day').format(apiDateFormat)
                    data.date_to_local = moment().endOf('day').format(apiDateFormat)
                    break;
                }
                case CONSTANTS.LAST7DAYS: {
                    data.date_from_local = moment().subtract(7, 'days').startOf('day').format(apiDateFormat)
                    data.date_to_local = moment().endOf('day').format(apiDateFormat)
                    break;
                }
                case CONSTANTS.CUSTOM: {
                    data.date_from_local = moment(this.dateRange.dateFrom).format(apiDateFormat)
                    data.date_to_local = moment(this.dateRange.dateTo).format(apiDateFormat)
                    break;
                }
            }
            let placeGuids = []
            this.placesFilter.selection.forEach((place) => {
                placeGuids.push(place.uid)
            })
            data.place_uids = placeGuids
            if(placeGuids.length == 0) {
                data.places_with_votes = true
            }
            return data
        },
        async refreshAll() {
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'load map data'
                })
                this.loadingAction = true
                let data = this.prepareRequestData()
                data.show_air_compare = `${this.showAirCompare}`
                let start = (new Date()).getTime()
                console.log(`DDDDD before get report`)
                const response = await this.getMapReportGeoJson(data)
                let afterGetReport = (new Date()).getTime()
                this.geoJsonData = response
                console.log(`got response:`, response)

                this.refreshDataWithFilters(true)
                this.mapBox.firstRenderFinished = false
                this.setupMapBoxMap()

                console.log(`DDDDD after get report: ` + (afterGetReport - start))
                // this.items.splice(0, this.items.length);
                let afterSplice = (new Date()).getTime()
                console.log(`DDDDD after splice: ` + (afterSplice - afterGetReport))

                let afterForeach = (new Date()).getTime()
                console.log(`DDDDD after foreach: ` + (afterForeach - afterSplice))
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'load map data'
                })
            }

            if(this.mapOverlay.show) {
                await this.refreshQuestionsGps()
            } else {
                this.clearAssetsOnTheMap()
            }
        },

        onPlacesFilterChanged(value) {
            this.refreshAll()
        },

        clearAssetsOnTheMap() {
            console.log('clearAssetsOnTheMap')
            this.assetsData = {}
            this.currentMapBoxAssetsData = this.getEmptyFeatureCollection()
            if(this.mapBoxMap && this.mapBoxMap.getSource('assets_points')) {
                this.mapBoxMap.getSource('assets_points').setData(this.currentMapBoxAssetsData)
            }

            // let result = {}
            // for (let i = 0; i < this.assetTypesTotal; i++) {
            //     result[i] = this.getEmptyFeatureCollection()
            // }
            // this.mapBoxAssetsData = result
            // this.applyMapBoxSourceData()
        },
        getEmptyFeatureCollection() {
            return {
                type: "FeatureCollection",
                features: [],
            }
        },
        async refreshQuestionsGps() {
            try {
                // this.setProgressBarTag({
                //     show: true,
                //     tag: 'load assets data'
                // })
                let data = this.prepareRequestData()
                // data.show_air_compare = `${this.showAirCompare}`
                let start = (new Date()).getTime()
                console.log(`FFFFFF before get report`)
                const response = await this.getMapQuestionsGeoJson(data)
                let afterGetReport = (new Date()).getTime()
                this.assetsData = response
                console.log(`got response:`, response)
                console.log(`FFFFFF after get report: ` + (afterGetReport - start))
                this.refreshAssetsDataWithFilters()
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                // this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'load assets data'
                })
            }
        },
        refreshAssetsDataWithFiltersOld(force = false) {
            if(!this.mapOverlay.show) {
                return
            }
            // for (const [key, value] of Object.entries(this.mapBoxAssetsData)) {
            //     console.log(`${key}: ${value}`);
            // }

            let items = this.assetsData.items
            if(!items || items.length == 0) {
                this.clearAssetsOnTheMap()
            }

            let result = {
                type: "FeatureCollection",
                features: [],
            }

            for (let i = 0; i < items.length; i++) {
                let item = JSON.parse(JSON.stringify(items[i]))
                let filters = {
                    q_id: true,
                }
                if(this.filterQId.trim() != '') {
                    filters.q_id = `${this.filterQId}` == `${item.q_id}`
                }
                if(!filters.q_id) {
                    continue
                }
                result.features.push({
                    geometry: {type: "Point", coordinates: [item.latlng.lng, item.latlng.lat]},
                    properties: {a_id: item.a_id, q: item.q_id, p: item.p, t: item.t },
                    type: "Feature",
                })
            }
            this.mapBoxAssetsData = result
            this.applyMapBoxSourceData()
        },
        applyMapBoxSourceData() {
            for (let i = 0; i < this.assetTypesTotal; i++) {
                let sourceName = 'assets_' + i
                if(this.mapBoxMap && this.mapBoxMap.getSource(sourceName)) {
                    if(this.mapBoxAssetsData.hasOwnProperty(i)) {
                        this.mapBoxMap.getSource(sourceName).setData(this.mapBoxAssetsData[i])
                    } else {
                        this.mapBoxMap.getSource(sourceName).setData(this.getEmptyFeatureCollection())
                    }
                }
            }
            this.mapBox.needRefreshCache = true
        },
        refreshAssetsDataWithFilters(force = false) {
            console.log(`refreshAssetsDataWithFilters`)
            //todo here assets data is filtered
            //todo here assets data is filtered
            //todo here assets data is filtered
            let items = this.assetsData.items
            if(!items || items.length == 0) {
                this.clearAssetsOnTheMap()
            }

            let groupedFeatures = []

            for (let i = 0; i < items.length; i++) {
                let item = JSON.parse(JSON.stringify(items[i]))
                let filters = {
                    placement: true,
                    q_id: true,
                }

                // if(this.filterPlacement.trim() != '') {
                //     filters.placement = this.compareSubstrings(this.filterPlacement, item.p)
                // }
                if(this.filterQId.trim() != '') {
                    filters.q_id = `${this.filterQId}` == `${item.q_id}`
                }
                if(!filters.q_id) {
                    continue
                }
                groupedFeatures.push({
                    geometry: {type: "Point", coordinates: [item.latlng.lng, item.latlng.lat]},
                    properties: {a_id: item.a_id, q: item.q_id, p: item.p, t: item.t, date: item.date, s: item.s, i: item.i },
                    type: "Feature"
                })
            }

            let geoJsonData = {
                type: "FeatureCollection",
                features: groupedFeatures,
            }
            this.currentMapBoxAssetsData = geoJsonData
            if(this.mapBoxMap && this.mapBoxMap.getSource('assets_points')) {
                this.mapBoxMap.getSource('assets_points').setData(geoJsonData)
            }
            this.mapBox.needRefreshCache = true

            if(this.moveMapTo) {
                let flyTo = {center: [this.moveMapTo.lng, this.moveMapTo.lat],}
                if(this.moveMapTo.zoom) {
                    flyTo.zoom = this.moveMapTo.zoom
                }
                this.mapBoxMap.flyTo(flyTo);
                this.moveMapTo = null
            } else {
                if(!this.currentMapBoxData || !this.currentMapBoxData.features || this.currentMapBoxData.features.length == 0) {
                    if (groupedFeatures.length > 0) {
                        var bounds = groupedFeatures.reduce(function (bounds, feature) {
                            return bounds.extend(feature.geometry.coordinates);
                        }, new mapboxgl.LngLatBounds(groupedFeatures[0].geometry.coordinates, groupedFeatures[0].geometry.coordinates));
                        this.mapBoxMapBounds = bounds
                        this.fitMapToMarkersBounds()
                    }
                }
            }
        },

        refreshDataWithFilters(force = false) {
            let features = this.geoJsonData.features
            if(this.filterPlacement.trim() == '' && this.filterSld.trim() == '') {
                if(this.isShowingAllItems && !force) {
                    console.log(`isShowingAllItems returning`)
                    return
                }
            } else {
                // features = this.geoJsonData.features.filter(item => {
                //     return this.compareSubstrings(this.filterPlacement, item.properties.p)
                //     || this.compareSubstrings(this.filterSld, item.properties.sl)
                // })
            }
            let groupedFeaturesMap = {}
            for (let i = 0; i < features.length; i++) {
                let item = JSON.parse(JSON.stringify(features[i]))
                let filters = {
                    placement: true,
                    sld: true,
                    q_id: true,
                }

                if(this.filterPlacement.trim() != '') {
                    filters.placement = this.compareSubstrings(this.filterPlacement, item.properties.p)
                }
                if(this.filterSld.trim() != '') {
                    filters.sld = this.compareSubstrings(this.filterSld, item.properties.sl)
                }
                if(this.filterQId.trim() != '') {
                    filters.q_id = `${this.filterQId}` == `${item.properties.q}`
                }
                if(!filters.placement || !filters.sld || !filters.q_id) {
                    continue
                }

                let id = `${item.geometry.coordinates[1]}${item.geometry.coordinates[0]}`
                function handleRelatedIds(existingItem, newItem) {
                    if(Array.isArray(existingItem.properties.rates)) {
                        existingItem.properties.rates.push(newItem)
                    } else {
                        let items = [JSON.parse(JSON.stringify(existingItem)), newItem]
                        existingItem.properties.rates = items
                    }
                    if(Array.isArray(existingItem.properties.ratesIds)) {
                        existingItem.properties.ratesIds.push(newItem.properties.r)
                    } else {
                        let ids = [existingItem.properties.r, newItem.properties.r]
                        existingItem.properties.ratesIds = ids
                    }
                    existingItem.properties.r = null
                    existingItem.properties.q = null
                    existingItem.properties.p = null
                    existingItem.properties.sl = null
                    // if(Array.isArray(existingItem.properties.q)) {
                    //     existingItem.properties.q.push(newItem.properties.q)
                    // } else {
                    //     let ids = [existingItem.properties.q, newItem.properties.q]
                    //     existingItem.properties.q = ids
                    // }
                }
                if(groupedFeaturesMap.hasOwnProperty(id)) {
                    if(item.properties.h > 0) {
                        handleRelatedIds(groupedFeaturesMap[id], item)
                        groupedFeaturesMap[id].properties.h = groupedFeaturesMap[id].properties.h + 1
                    } else if(item.properties.g > 0) {
                        handleRelatedIds(groupedFeaturesMap[id], item)
                        groupedFeaturesMap[id].properties.g = groupedFeaturesMap[id].properties.g + 1
                    } else if(item.properties.s > 0) {
                        handleRelatedIds(groupedFeaturesMap[id], item)
                        groupedFeaturesMap[id].properties.s = groupedFeaturesMap[id].properties.s + 1
                    }
                } else {
                    groupedFeaturesMap[id] = item
                }
            }
            let groupedFeatures = []
            for (const [key, item] of Object.entries(groupedFeaturesMap)) {
                groupedFeatures.push(item)
            }

            let geoJsonData = {
                type: "FeatureCollection",
                features: groupedFeatures,
            }
            this.mapBox.needRefreshCache = true
            this.currentMapBoxData = geoJsonData
            this.isShowingAllItems = geoJsonData.features.length == this.geoJsonData.features.length
            if(this.mapBoxMap && this.mapBoxMap.getSource('votes_points')) {
                this.mapBoxMap.getSource('votes_points').setData(geoJsonData)
            }
            if(features.length > 0) {
                var bounds = features.reduce(function (bounds, feature) {
                    return bounds.extend(feature.geometry.coordinates);
                }, new mapboxgl.LngLatBounds(features[0].geometry.coordinates, features[0].geometry.coordinates));
                this.mapBoxMapBounds = bounds
                this.fitMapToMarkersBounds()
            }
            this.mapBox.needRefreshCache = true
        },

        compareSubstrings(search, str) {
            let minusMode = search && search.startsWith("-")
            return (search && str)
                && (
                    (!minusMode && str.toLowerCase().includes(search.toLowerCase()))
                    || (minusMode && !str.toLowerCase().includes(search.substring(1).toLowerCase()))
                )
        },

        getAutocompleteAddressCollection() {
            this.autocompleteAddressCollection = new Promise((resolve, reject) => {
                this.searchAddressAutocomplete({searchText: this.searchAddressQuery, isGeocode:true})
                    .then((response) => {
                        let res = response.items
                        for (let i = 0; res.length > i; i++) {
                            let item = res[i]
                            item.toLowerCase = () => item.description.toLowerCase()
                            item.toString = () => item.description
                        }
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },

        async onSearchAddressChanged() {
            this.getAutocompleteAddressCollection()
        },

        async onSearchAddressSelect(address) {
            this.searchAddressQuery = address.description
            this.setProgressBarTag({
                show: true,
                tag: 'load address'
            })
            const placeId = address.placeId
            try {
                let response = await this.geocodeGooglePlaceId({placeId:placeId})
                console.log(`set map from address`)
                const point = {
                    center: [response.latLng.lng, response.latLng.lat],
                    zoom: 12,
                    // bearing: 130,
                    // pitch: 75,
                    duration: 4000,
                    essential: true,
                };
                this.mapBoxMap.flyTo(point);

                // this.reclusterItems()
            } catch (e) {
                console.log(`error onSearchAddressSelect`, e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'load address'
                })
            }

        },

        returnToMain() {
			this.$router.go(-1)
		},

        onAssetsMapBtnClick() {

            // let url = `${location.origin}/places/${this.userInfo.assets_map_access.guid}/map`
            // window.open(url, '_blank')

            this.mapOverlay.show = true
            try {
                this.logUserAction({ action: 'assets_map_dashboard_click'})
            } catch (e) {}
        },

        async onPlacementChanged(placement) {
            console.log(`placement: ${placement}`)
            this.refreshDataWithFilters()
            this.refreshAssetsDataWithFilters()
        },

        async onSldFilterChanged(filter) {
            console.log(`new sld filter: ${filter}`)
            this.refreshDataWithFilters()
            this.refreshAssetsDataWithFilters()
        },

        async onQuestionIdFilterChanged(filter) {
            console.log(`new question id filter: ${filter}`)
            this.refreshDataWithFilters()
            this.refreshAssetsDataWithFilters()
        },

        async showVotesSidebar(features) {
            this.closeAssetSidebar()
            console.log('showVotesSidebar:', features)
            this.setMapLeftPadding(350)
            this.votesSidebar.visible = true
            const elem = document.getElementById('votes_sidebar');
            elem.classList.remove('collapsed')

            // this.votesSidebar.votes = features
            await this.loadVotesDetailed(features)
        },

        async loadVotesDetailed(features) {
            let ratesIds = []
            features.forEach(item => {
                if(item.properties.r) {
                    ratesIds.push(item.properties.r)
                } else if(item.properties.ratesIds) {
                    let ids = item.properties.ratesIds
                    if(!Array.isArray(ids)) {
                        ids = JSON.parse(ids)
                    }
                    ratesIds = ratesIds.concat(ids)
                }
            })
            // let ids = features.filter(item => item.properties.r).map(item => item.properties.r)
            let data = { ids: ratesIds }
            try {
                this.votesSidebar.loading = true
                this.votesSidebar.votes = []
                this.votesSidebar.votesFiltered = []
                const response = await this.getMapRatesReport(data)
                this.votesSidebar.votes = response.votes
                this.votesSidebar.votesFiltered = response.votes
                this.votesSidebar.stats = response.stats
                this.votesSidebar.totalQuestions = response.questions_count
                this.refreshVotesSidebarFilters()
                //todo check if empty?
            } catch (e) {
                console.log(e)
                this.showErrorModal("Shomething went wrong")
                this.closeVotesSidebar()
            } finally {
                this.votesSidebar.loading = false
            }
        },

        refreshVotesSidebarFilters() {
            if(this.votesSidebar.withDetailsOnly) {
                this.votesSidebar.votesFiltered = this.votesSidebar.votes.filter((item) => {
                    return item.comment != ''
                    || (item.sec_level && item.sec_level.length > 0)
                    || item.attachments.images.length > 0
                    || item.attachments.images.audio
                    || item.contact_info != ''
                })
            } else {
                this.votesSidebar.votesFiltered = this.votesSidebar.votes
            }
        },

        onVotesSidebarCloseClick() {
            this.closeVotesSidebar()
        },

        closeVotesSidebar() {
            this.setMapLeftPadding(0)
            this.votesSidebar.visible = false
            const elem = document.getElementById('votes_sidebar');
            elem.classList.add('collapsed')
            // this.votesSidebar.votes = []
        },

        async showAssetSidebar(feature) {
            this.closeVotesSidebar()
            console.log('showAssetSidebar:', feature)
            // this.setMapLeftPadding(350)

            const coordinates = feature.geometry.coordinates.slice();
            let properties = feature.properties

            let date = moment(properties.date).format("MMM D YYYY, h:mm a")
            this.assetSidebar.dateFormatted = date
            let author = properties.s != '' ? ` by ${properties.s}` : ''
            this.assetSidebar.author = author
            this.assetSidebar.asset_id = properties.a_id
            this.assetSidebar.question_id = properties.q
            this.assetSidebar.coordinates.lat = coordinates[1]
            this.assetSidebar.coordinates.lng = coordinates[0]

            this.assetSidebar.visible = true
            const elem = document.getElementById('asset_sidebar');
            elem.classList.remove('collapsed')
            this.loadAssetAdditionalData()
        },
        async loadAssetAdditionalData() {
            try {
                //todo show progressbar?
                const response = await this.getQuestionById(this.assetSidebar.question_id)
                console.log(response)
                this.assetSidebar.question = response
            } catch (e) {
                console.log('error fetching question data')
            } finally {

            }
        },
        onAssetSidebarCloseClick() {
            this.closeAssetSidebar()
        },
        closeAssetSidebar() {
            // this.setMapLeftPadding(0)
            this.assetSidebar.question = null
            this.assetSidebar.visible = false
            const elem = document.getElementById('asset_sidebar');
            elem.classList.add('collapsed')
        },
        onOpenAssetInGoogleClick() {
            let lat = this.assetSidebar.coordinates.lat
            let lng = this.assetSidebar.coordinates.lng
            window.open(`https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},17z`, '_blank').focus();
        },

        onFixLocationIssueClick() {
            this.customModalSettings = {
                icon: 'ic_gps_broblem.svg',
                title: '',
                message: 'This will confirm that the problem is fixed',
                okButtonText: 'Continue',
                onOkHandler: () => {
                    this.fixLocationIssue(this.assetSidebar.question)
                },
                showCancelButton: true,
                cancelButtonText: this.translate('Cancel'),
            }
        },
        async fixLocationIssue(item) {
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'fix issue'
                })
                this.loadingAction = true
                const response = await this.fixLocationIssueForQuestionA({guid: item.guid})
                item.has_issue = false

                var index = this.assetsData.items.findIndex(item_ => `${item_.q_id}` === `${item.id}`)
                console.log(`fixLocationIssue item found index=${index}`)
                if (index > -1) {
                    let item = this.assetsData.items.splice(index, 1)[0];
                    console.log(`fixLocationIssue item found item`, item)
                    item.i = 0
                    this.assetsData.items.push(item)
                }
                this.unspiderfyAll()
                this.refreshAssetsDataWithFilters()

            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'fix issue'
                })
            }
        },

        setMapLeftPadding(padding) {
            if(this.mapBoxMap) {
                this.mapBoxMap.easeTo({
                    padding: {
                        left: padding,
                    },
                    duration: 1000,
                });
            }
        },

        onVoteImageClick(item) {
            window.open(item.originUrl, '_blank')
        },

        shouldShowAnswer(rate) {
            return rate.answer == null ? false : (rate.rate == 3 && this.translate('own_Happy').toUpperCase() !== rate.answer.toUpperCase()) || (rate.rate == 2 && this.translate('own_SoSo').toUpperCase() !== rate.answer.toUpperCase()) || (rate.rate == 1 && this.translate('own_Sad').toUpperCase() !== rate.answer.toUpperCase())
        },

        shouldShowMapLink(vote) {
            return vote.rate_location != null
        },

        getGeolocationGoogleMapLink(vote) {
            let loc = vote.rate_location
            if(loc == null) return ''
            return `https://www.google.com/maps/place/${loc.lat},${loc.lng}/@${loc.lat},${loc.lng},17z`
        },

        onEnterFCModeClick() {
            const elem = document.getElementById('map');
            elem.classList.add('fullscreen')
            this.mapBoxMap.resize()
        },

        onLeaveFCModeClick() {
            const elem = document.getElementById('map');
            elem.classList.remove('fullscreen')
            this.mapBoxMap.resize()
        },
        onAVLogoClick() {
            console.log(`onAVLogoClick`)
            this.$router.push({name: 'OwnerPlaceManagement'})
        },
        onAVLogoContextMenuClick() {
            console.log(`onAVLogoContextMenuClick`)
            if(this.checkIfOwnerHaveOriginalCredential()) {
                this.showAdminBlocks = !this.showAdminBlocks
            }
        },
        checkIfOwnerHaveOriginalCredential() {
            return localStorage.getItem('originalCredentials') !== null
        },
        unspiderfyAll() {
            if(this.clustersSpiderfy) {
                console.log(`unspiderfyAll`)
                this.clustersSpiderfy.unspiderfyAll()
            }
        },
        onChangeMapModeClick() {
            this.mapBox.isSatelliteMode = !this.mapBox.isSatelliteMode
        },
        onShowLocationHistoryClick() {
            this.showLocationHistory(this.assetSidebar.question.guid, this.assetSidebar.asset_id)
        },
        showLocationHistory(questionId, assetId) {
            this.mapLocationHistorySettings.data = {
                historyData: null,
                questionId: questionId,
                assetId: assetId,
            }
            this.mapLocationHistorySettings.show = !this.mapLocationHistorySettings.show
        },
        showContextMenu(element) {
            if(!this.mapBoxMap) return
            let lngLat = element.lngLat

            // var el = document.createElement('div');
            // el.innerHTML = `<div style='background-color:red;width:20px;height:20px;'>_</div>`
            // new mapboxgl.Marker(el)
            //     .setLngLat([lngLat.lng, lngLat.lat])
            //     .addTo(this.mapBoxMap);
            // return;

            this.closeMapContextMenuPopup()
            let popup = new mapboxgl.Popup({
                className: "map-context-menu-popup",
                closeOnClick:true,
                closeOnMove:true,
                closeButton:false,
                offset: [0, 0],
            })
                .setLngLat([lngLat.lng, lngLat.lat])
                .setDOMContent(this.$refs.map_context_menu_popup)
                .addTo(this.mapBoxMap);
            this.mapContextMenuPopup = popup
        },
        closeMapContextMenuPopup() {
            if(this.mapContextMenuPopup) {
                this.mapContextMenuPopup.remove()
                this.mapContextMenuPopup = null
            }
        },
        onSetUnitGeolocationClick() {
            let coords = this.mapContextMenuPopup.getLngLat()

            console.log('onSetUnitGeolocationClick')
            this.showSetGPSSidebar(coords)
        },
        onZoomToPointClick() {
            let coords = this.mapContextMenuPopup.getLngLat()
            this.mapBoxMap.flyTo({
                center: coords,
                zoom: 15,
                // duration: 500
            });
            console.log('onZoomToPointClick')
        },

        async showSetGPSSidebar(lngLat) {
            this.closeSetGPSSidebar()
            console.log('showSetGPSSidebar:', lngLat)
            this.setMapLeftPadding(350)

            this.setGPSSidebar.item_id = ''
            this.setGPSSidebar.coordinates.lat = lngLat.lat
            this.setGPSSidebar.coordinates.lng = lngLat.lng
            this.setGPSSidebar.visible = true
            console.log('setGPSSidebar:', this.setGPSSidebar)
            const elem = document.getElementById('set_gps_sidebar');
            elem.classList.remove('collapsed')

        },
        onSetUnitGpsItemIdChanged(value) {
            //todo?
        },
        onSetGpsSidebarToggleTypeQuestionClick() {
            this.setGPSSidebar.type = 'question_id'
        },
        onSetGpsSidebarToggleTypeAssetIdClick() {
            this.setGPSSidebar.type = 'asset_id'
        },
        closeSetGPSSidebar() {
            this.setGPSSidebar.item_id = ''
            this.setGPSSidebar.visible = false
            const elem = document.getElementById('set_gps_sidebar');
            elem.classList.add('collapsed')
        },
        setGPSSidebarStaticMapGeojson(){
            let value = `{
            "type":"Feature",
            "properties":{
            "marker-color":"#3F405C",
            "marker-size":"large",
            "marker-symbol":null},
            "geometry":{"type":"Point","coordinates":[${this.setGPSSidebar.coordinates.lng},${this.setGPSSidebar.coordinates.lat}]}}`
            return encodeURIComponent(value)
        },
        async onSetGpsSaveClick() {
            let body = {
                id_value: this.setGPSSidebar.item_id,
                type: this.setGPSSidebar.type,
                lng: this.setGPSSidebar.coordinates.lng,
                lat: this.setGPSSidebar.coordinates.lat,
            }
            try {
                const response = await this.assignGpsToQuestion(body)
                this.setMessageModel({
                    msg: 'New geolocation assigned successfully',
                    duration: 1500
                })
                this.closeSetGPSSidebar()
                this.moveMapTo = {
                    lat: body.lat,
                    lng: body.lng,
                    zoom: 15,
                }
                this.refreshQuestionsGps()
            } catch (e) {
                if(e.data.error.code == 1044) {
                    this.showErrorModal("Asset not found", {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } else if(e.data.error.code == 1231) {
                    let ids = e.data.error.details.qr_ids
                    this.showErrorModal(`Multiple assets have this asset id: ${ids}.\nPlease use AirVote ID to assign the geolocation`, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } else {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            }
            console.log(`assignGpsToQuestion response`, response)
            //todo handle errors and success
        },
    }
}
</script>

<style>
.multiselect--active {
    z-index: 99999;
}
.map-header .multiselect__tags {
    /*height: 36px;*/
    min-height: 36px;
    padding: 6px 34px 0 6px;
    font-size: 15px;
}

.map-header .multiselect__tag {
    background-color: #36BC00;
}

.map-header .multiselect__tag-icon:after {
    color: white;
}

.map-header .multiselect__option--selected.multiselect__option--highlight {
    background: rgba(205, 0, 0, 0.93);
    color: #fff;
}

.map-header .multiselect__option--selected {
    background: #f3f3f3;
    color: #35495e;
    font-weight: 700;
}

.map-header .multiselect__option--highlight {
    background: rgba(54, 188, 0, 0.85);
    outline: none;
    color: #fff;
}

.leaflet-control-attribution {
    display: none;
}
.leaflet-div-icon {
    background: none;
    border: none;
}
.cluster_block {
    border: 1px solid white;
    width: fit-content;
    padding: 6px;
    background: white;
    border-radius: 10px;
}
.cluster_inner {
    display: flex;
    flex-direction: row;
}
.cluster_wrapper {
    background: #FFFFFFD9;
    display: flex;
    flex-direction: column;
    width: fit-content;
    padding: 6px;
    border-radius: 10px;
}
.cluster_no_votes {
    font-size: 8px;
    margin-top: 4px;
}
.cluster_legend {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    justify-content: center;
    max-height: 30px;
    font-size: 8px;
}
.pie {
    width: 30px;
    background: #438348;
    border-radius: 50%;
}
.pie circle {
    fill: none;
    stroke: #438348;
    stroke-width: 32;
}
.no_votes_marker {
    background: #FFFFFFD9;
    display: flex;
    flex-direction: row;
    width: fit-content;
    padding: 6px;
    border-radius: 10px;
}
.map-dashboard .mapboxgl-marker-anchor-center {
    cursor: pointer;
}
.airCompare_wrapper .custom-control-label {
    cursor: pointer;
}
.airCompare_wrapper input {
    cursor: pointer;
}
.verte__menu-origin {
    z-index: 99999;
}
.back-color {
    cursor: pointer;
    width: 24px;
    height: 24px;
}
.back-color.color-white {
    background-color: white;
}
.back-color.color-pink {
    background-color: deeppink;
}

.map-mode-btn {
    width: 30px;
    height: 30px;
    background: green;
    border-radius: 4px;
    margin-right: 8px;
    cursor: pointer;
    background-size: 30px;
}
.map-mode-btn.satellite {
    background: url('../../assets/icons/img_map_satellite.png') no-repeat;
    background-size: 30px;
}
.map-mode-btn.default {
    background: url('../../assets/icons/img_map_default.png') no-repeat;
    background-size: 30px;
}
.votes_detailed_main_container {
    position: absolute;
    z-index: 1000;
    top: 0;
    bottom: 0;
    left: 0;
    transition: transform 1s;
    pointer-events: none;
}
.votes_detailed_main_container.collapsed {
    transform: translateX(-380px);
}
.votes_detailed_wrapper {
    position: static;
    z-index: 999;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.votes_detailed {
    position: relative;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 4px;
    padding: 14px;
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 8px;
    margin-bottom: 8px;
    overflow: hidden;
    width: 350px;
    min-width: 350px;
    max-width: 350px;
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.11);
    pointer-events: auto;
}
.votes_detailed_header {
    font-size: 15px;
    font-weight: 800;
}
.votes_detailed_subheader_wrapper {
    margin-bottom: 8px;
    margin-top: 2px;
}
.votes_detailed_subheader {
    font-size: 14px;
}
.set_gps_sidebar_title {
    font-size: 15px;
    font-weight: 800;
}
.sgs_title {
    font-size: 14px;
}
.sgs_map-preview {
    margin-top: 10px;
}
.set_gps_sidebar_toggle_wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 16px;
}
.set_gps_sidebar_toggle_wrapper-toggles {
    display: flex;
    flex-direction: row;
    gap: 6px;
    margin-top: 0px;
}
.set_gps_sidebar_toggle_item {
    width: 110px;
    height: 24px;
    background: white;
    color: #3F405C;
    border: 1px solid #3F405C;
    cursor: pointer;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
}
.set_gps_sidebar_toggle_item:hover, .set_gps_sidebar_toggle_item.active {
    background: #3F405C;
    color: white;
}
.set_gps_sidebar_qid_input_wrapper {
    margin-top: -4px;
    display: flex;
    flex-direction: row;
}
/* Chrome, Safari, Edge, Opera */
.set_gps_sidebar_qid_input_wrapper input::-webkit-outer-spin-button,
.set_gps_sidebar_qid_input_wrapper input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* Firefox */
.set_gps_sidebar_qid_input_wrapper input[type=number] {
    -moz-appearance: textfield;
}
.set_gps_sidebar_save {
    height: 30px;
    width: 74px;
    background: #3F405C;
    cursor: pointer;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 14px;
    margin-top: 12px;
    align-self: end;
}
.asset_details_id {
    font-size: 14px;
}
.asset_id {
    font-weight: 800;
}
.asset_details_info {
    font-size: 14px;
}
.asset_popup_btns {
    display: flex;
    column-gap: 6px;
    /*justify-content: end;*/
    /*padding-right: 24px;*/
}
.asset_popup_btns .link_btn {
    cursor: pointer;
    color: #0e76a8;
    text-decoration: underline;
}
.asset_popup_btns .link_btn:hover {
    text-decoration: none;
    color: #094c6c;
}
.votes_detailed_container {
    display: flex;
    flex-direction: column;
    overflow: scroll;
    overflow-x: hidden;
    gap: 8px;
    z-index: 999;
}
.votes_detailed_loading {
    height: 40px;
    display: flex;
    align-items: center;
}
.votes_detailed_close {
    position: absolute;
    right: 11px;
    top: 8px;
    cursor: pointer;
    font-size: 14px;
}
.votes_detailed_close:hover {
    text-decoration: underline;
}
.votes_detailed_vote_wrapper:first-child {
    border-top: none;
}
.votes_detailed_vote_wrapper {
    line-break: anywhere;
    /*border-top: 1px solid rgba(0, 0, 0, 0.25);*/
    padding-bottom: 4px;
    padding-top: 4px;
}
.map-context-menu-popup {
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}
.map-context-menu-popup .mapboxgl-popup-tip {
    display: none;
}
.map-context-menu-popup .mapboxgl-popup-content {
    padding: 0;
}
.map-context-menu-popup .menu-item {
    padding: 6px;
    cursor: pointer;
}
.map-context-menu-popup .menu-item:hover {
    padding: 6px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.08);
}
.map-context-menu-popup .menu-item:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.map_context_menu_popup_container {
    position: absolute;
}
.map_context_menu_popup {
    /*position: absolute;*/
}
@media screen and (max-width: 700px) {
    .votes_detailed_main_container {
        width: 100%;
    }

    .votes_detailed {
        width: unset;
        min-width: 300px;
        max-width: 100%;
    }

    .votes_detailed_main_container.collapsed {
        transform: translateX(-105%);
    }
}

</style>

<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.map-dashboard {
    z-index: 1000;
    display: flex;
    justify-content: center;
    max-width: 100% !important;
    width: 100% !important;
    height: 100%;
    margin-top: 0 !important;
}
.map-header {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
}
.map-logo {
    width: 100px;
    cursor: pointer;
}
.map-logo img {
    width: 100px;
    min-width: 100px;
}
.map {
    width: 100%;
    height: 100%;
    z-index: 99;
}
.map.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: unset;
}
.map .fc_wrapper {
    position: absolute;
}
.map .fc_wrapper.leave {
    display: none;
}
.map.fullscreen .fc_wrapper.enter {
    display: none;
}

.md-field {
	margin: 0;
	padding-top: 18px;
}
.md-field.md-has-value label {
	top: -2px;
}
.md-field.md-focused label {
	top: -2px;
}
.refresh-btn {
    cursor: pointer;
    color: #31629c;
    display: flex;
    right: 0;
    justify-content: flex-end;
    margin-top: 15px;
    padding-right: 15px;
    position: absolute;
    bottom: 24px;
    z-index: 99;
}

.range {
    flex-direction: column;
    align-items: start;
}

.range-select {
    flex-direction: row;
    display: flex;
}
.map-dashboard .legend_wrapper {
    display: flex;
    align-items: center;
    margin-right: 16px;
    padding-top: 12px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 4px;
}
.map-dashboard .address_wrapper {
    display: flex;
    align-items: center;
    margin-right: 0px;
    padding-left: 0px;
    padding-right: 0px;
    border-radius: 4px;
    margin-bottom: 4px;
}
.map-dashboard .address_wrapper.sld_filter {
    max-width: 160px;
}
.map-dashboard .address_wrapper.placement_filter {
    max-width: 160px;
}
.map-dashboard .address_wrapper.question_id_filter {
    max-width: 56px;
}
/* Chrome, Safari, Edge, Opera */
.question_id_filter input::-webkit-outer-spin-button,
.question_id_filter input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* Firefox */
.question_id_filter input[type=number] {
    -moz-appearance: textfield;
}

.range-select .search_places {
    width: 170px;
    background-color: #F7F7F7 !important;
    margin-top: -5px;
}

.range-select__wrapper {
    display: flex;
    margin-bottom: 12px;
    column-gap: 20px;
    flex-wrap: wrap;
}

.custom_date_selector .form-control {
    height: 36px;
}

.map-dashboard .dropdown-range {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 12px 0px;
    border-radius: 4px;
    margin-right: 0px;
}

.dropdown-range.dates {
    padding-top: 0;
    padding-bottom: 0;
}

.custom_date_selector {
    display: flex;
    flex-direction: row;
}

.custom_date_selector input {
    border-bottom: 1px solid black;
}

.custom_date_selector .hide-picker /deep/ .bootstrap-datetimepicker-widget {
    display: none !important;
}

.custom_date_selector .btn {
    width: auto;
    height: 20px;
    padding: 0;
    margin: auto;
}

.date_lbl {
    width: 50px;
    margin: auto;
    text-align: right;
    margin-right: 8px;
}


.main-container {
    position: fixed;
    max-width: 1280px;
    width: 95%;
    margin-top: 16px;
    background: #F3F3F3;
    display: flex;
    flex-direction: column
}

.items-container {
    padding-bottom: 16px;
    margin-top: 16px;
    width: 100%;
    margin-right: 16px;
    border-radius: 4px;
    min-height: 150px;
    overflow-x: auto;
    overflow-y: scroll;
    max-height: 95%;
    background: #ffffff;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.range h6 {
    color: #2F2F2F;
    font-family: 'Nunito';
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 18px;
	margin-bottom: 0;
	margin-top: 6px;
}

.range .dropdown /deep/ button.btn-secondary {
    background: none !important;
    border: 0;
    display: flex;
    align-items: center;
    color: #2F2F2F;
    font-weight: 700;
    position: relative;
    padding: 5px 50px 5px 0;
    margin-left: 0;
    font-size: 16px;
    font-family: 'Nunito';
}

.range /deep/ .dropdown-menu {
    width: auto !important;
}

.range .dropdown:before {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    content: " ";
    background: #3F405C;
    width: 100%;
    height: 1px;
}

.range .dropdown:after {
    content: '';
    height: 7px;
    width: 7px;
    transform: rotate(45deg);
    right: 10px;
    top: 10px;
    position: absolute;
    border-bottom: 2px solid black;
    border-right: 2px solid black;
}
.returnBtn-container {
	margin-bottom: 34px;
}
.assetsMapBtn_wrapper {
    display: flex;
    align-items: end;
    padding-bottom: 10px;
}
.airCompare_wrapper {
    display: flex;
    align-items: center;
}
.assetsMapBtn {
    height: 40px;
    background-color: #3F405C;
    padding-left: 12px;
    padding-right: 12px;
    color: white;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    min-width: 110px;
}
.assetsMapBtn:hover {
    background-color: #292a3e;
}

.link_btn.fix-issue {
    color: #f16767;
}
.link_btn.fix-issue:hover {
    color: #952c2c;
}
.votes_detailed_cb {
    font-size: 13px;
}
.votes_happy {
    color: #36BC00;
}
.votes_soso {
    color: #FEB000;
}
.votes_sad {
    color: #EF4200;
}
.vd_date {
    font-size: 12px;
    color: #3c3c3c;
}
.vd_attachments {
    margin-top: 4px;
    height: 50px;
    overflow: scroll;
    overflow-y: hidden;
    display: flex;
}

.vd_attachments img {
    max-width: 100%;
    max-height: 50px;
    cursor: pointer;
    margin-right: 4px;
}

.votes_detailed li {
    padding: 10px 16px;
    width: 100%;
    margin: 0 0 0 0;
    border-radius: 4px;
    position: relative;
    /*overflow: hidden;*/
    background: #F7F7F7;
}
.votes_detailed li:last-child {
    margin-bottom: 0;
}

.votes_detailed li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.votes_detailed li[rate="3"]:before { background-color: #36BC00 }
.votes_detailed li[rate="2"]:before { background-color: #FEB000 }
.votes_detailed li[rate="1"]:before { background-color: #EF4200 }

.votes_detailed li .date {
    color: #6D6D6D;
    font-size: 13px;
    line-height: 18px;
    font-weight: 300;
    margin-bottom: 3px;
}

.votes_detailed li .question_id {
    position: absolute;
    right: 6px;
    top: 3px;
    color: #6D6D6D;
    font-size: 11px;
    line-height: 18px;
    font-weight: 300;
}

.votes_detailed li p {
    margin: 0;
    font-size: 13px;
    color: #2F2F2F;
}
.votes_detailed li .placement {
    color: #4e4e4e;
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;
    padding-bottom: 5px;
    padding-right: 2px;
    width: 100%;
    word-break: break-all;
}
.votes_detailed li .map_link {
    color: #212121;
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;
    padding-bottom: 5px;
    padding-right: 10px;
    width: 100%;
    word-break: break-all;
}
.votes_detailed li .map_link img {
    height: 19px;
    padding-bottom: 3px;
    padding-left: 4px;
    padding-right: 4px;
}
.votes_detailed li .map_link a {
    color: #535353;
    text-decoration: underline;
}
.votes_detailed li .answer {
    color: #6D6D6D;
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;
    padding-bottom: 5px;
    padding-right: 10px;
    width: 100%;
    word-break: break-all;
}
.votes_detailed li .answer.value-1 {
    color: #EF4200;
}
.votes_detailed li .answer.value-2 {
    color: #FEB000;
}
.votes_detailed li .answer.value-3 {
    color: #36BC00;
}

@media screen and (max-width: 800px) {
    .map-dashboard .address_wrapper {
        padding-left: 0px;
    }
    .assetsMapBtn_wrapper {
        margin-top: 15px;
    }
}
@media screen and (max-width: 700px) {
    .votes_detailed {
        width: unset;
        min-width: 300px;
        max-width: 100%;
    }
    .map {
        height: 500px;
    }
    .main-container {
        position: relative;
        width: 100%;
    }
    .map .fc_wrapper {
        bottom: 10px;
        width: 100%;
        display: flex;
    }
    .map.fullscreen .fc_wrapper.leave {
        display: flex;
    }
    .map .fc {
        position: relative;
        font-size: 14px;
        z-index: 999;
        background: white;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 12px;
        padding-right: 12px;
        border-radius: 4px;
        cursor: pointer;
        margin: auto;
    }
    .range-select__wrapper {
        column-gap: 12px;
    }
}

</style>
